export default class Location {
  constructor (data = {}) {
    this.locationId = data.location_id
    this.name = data.name
    this.address = data.address
    this.stateZip = [data.state, data.zip].filter((part) => part !== null).join(' ')
    this.address2 = data.city && data.city.trim() ? `${data.city.trim()}, ${this.stateZip}` : this.stateZip
    this.callTrackingNumber = data.call_tracking_number
  }
}
